(function ($) {
  "use strict";

  function openFirstFaqItem($category) {
    var $items = $category.find(".faq__item");

    $items.removeClass("active").find(".js-faq-answer").hide();
    $items.first().addClass("active").find(".js-faq-answer").show();
  }

  $(function () {
    $(".js-faq-category-item").on("click", function (e) {
      e.preventDefault();
      $(this)
        .parent()
        .find(".js-faq-category-item.active")
        .removeClass("active");
      $(this).addClass("active");
      $(".js-faq-category.active").removeClass("active");

      var $category = $(
        `.js-faq-category[id="${$(this).attr("href").substring(1)}"]`
      ).addClass("active");

      openFirstFaqItem($category);
    });

    $(".js-faq-question").on("click", function (e) {
      var $item = $(this).parent();
      var $answer = $(this).next(".js-faq-answer");
      var $section = $item.closest(".section__faqs");

      $section
        .find(".js-faq-answer")
        .not($answer)
        .slideUp();
      $section.find(".faq__item").not($item).removeClass("active");

      $item.toggleClass("active");
      $answer.slideToggle();
    });
  });
})(jQuery);
